import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'accountVaults');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    { type: 'payload', selector: ['userId'] },
    'accountvaults',
    {
      type: 'payload.query',
      queryParameter: 'subject_id',
      selector: 'subjectId',
    },
    {
      type: 'payload.query',
      queryParameter: 'subject_type',
      selector: 'subjectType',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/accountVaults.js